import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { RouterModule } from '@angular/router';

import { environment } from '../../../environments/environment';
import { SharedModule } from '../../shared.module';
import { HeaderComponent, SummaryCardComponent, ToolsCardComponent } from './components';
import { HomeComponent } from './home.component';

declare global {
  interface Window {
    Smart: any;
  }
}
window.Smart.License = environment.SMART_LICENSE_KEY;

@NgModule({
  declarations: [HomeComponent, HeaderComponent, SummaryCardComponent, ToolsCardComponent],
  exports: [HomeComponent],
  imports: [CommonModule, SharedModule, MatDividerModule, RouterModule]
})
export class HomeModule {}
